






















































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Area from "@/models/coding/areaModel";
import IndicatorType from '../../../models/indicator/indicatorType.model';
import GenericEdit from "@/core/Generics/GenericEdit";
@Component
export default class IndicatorTypeEdit extends GenericEdit<IndicatorType> {
  constructor() {

    super();
     this.controller = 'IndicatorTypes';
    this.model = new IndicatorType();
  }
  
  cancel(){ this.$router.push(`${this.$router.currentRoute.path.split('/editar')[0]}`)}

}
